import type { Brand } from "@health/types";
import type { LucideProps } from "lucide-react";
import {
  Brain,
  Flame,
  Heart,
  Pill,
  Scale,
  Scissors,
  Shield,
  Sparkles,
  TestTube,
} from "lucide-react";
import type { ComponentType } from "react";

export interface CategoryDisplayInfo {
  id: string;
  label: string;
  tagline: string;
  icon: ComponentType<LucideProps>;
  brands: Brand[];
  slug: string;
  readiness: number;
}

const CATEGORY_DISPLAY: CategoryDisplayInfo[] = [
  {
    id: "weight-loss",
    label: "Weight Loss",
    tagline: "GLP-1 treatments for sustainable results",
    icon: Scale,
    brands: ["hers", "hims"],
    slug: "weight-loss",
    readiness: 90,
  },
  {
    id: "sexual-health",
    label: "Sexual Health",
    tagline: "Testing, treatment & wellness",
    icon: Heart,
    brands: ["hers", "hims"],
    slug: "sexual-health",
    readiness: 50,
  },
  {
    id: "ed",
    label: "ED Treatment",
    tagline: "Discreet, effective options",
    icon: Shield,
    brands: ["hims"],
    slug: "ed",
    readiness: 15,
  },
  {
    id: "hair",
    label: "Hair",
    tagline: "Clinically proven hair restoration",
    icon: Scissors,
    brands: ["hers", "hims"],
    slug: "hair",
    readiness: 10,
  },
  {
    id: "skin",
    label: "Skincare",
    tagline: "Personalized prescription skincare",
    icon: Sparkles,
    brands: ["hers", "hims"],
    slug: "skin",
    readiness: 10,
  },
  {
    id: "mental-health",
    label: "Mental Health",
    tagline: "Anxiety & depression support",
    icon: Brain,
    brands: ["hers", "hims"],
    slug: "mental-health",
    readiness: 10,
  },
  {
    id: "menopause",
    label: "Menopause",
    tagline: "Hormone therapy & symptom relief",
    icon: Flame,
    brands: ["hers"],
    slug: "menopause",
    readiness: 5,
  },
  {
    id: "birth-control",
    label: "Birth Control",
    tagline: "Prescription delivery to your door",
    icon: Pill,
    brands: ["hers"],
    slug: "birth-control",
    readiness: 5,
  },
  {
    id: "labs",
    label: "Lab Testing",
    tagline: "At-home tests for hormones & more",
    icon: TestTube,
    brands: ["hers", "hims"],
    slug: "labs",
    readiness: 5,
  },
];

export function getCategoriesForBrand(brand: Brand): CategoryDisplayInfo[] {
  return CATEGORY_DISPLAY.filter((c) => c.brands.includes(brand));
}

export function getCategoryDisplay(id: string): CategoryDisplayInfo | undefined {
  return CATEGORY_DISPLAY.find((c) => c.id === id);
}

export function getCategoryBySlug(slug: string): CategoryDisplayInfo | undefined {
  return CATEGORY_DISPLAY.find((c) => c.slug === slug);
}

export function getReadinessColor(readiness: number): string {
  if (readiness > 75) return "text-green-600";
  if (readiness >= 25) return "text-yellow-600";
  return "text-gray-400";
}

export function getReadinessDotColor(readiness: number): string {
  if (readiness > 75) return "bg-green-500";
  if (readiness >= 25) return "bg-yellow-500";
  return "bg-gray-300";
}
